import React from "react";
import "../components/cookie.css"; // Make sure to create this CSS file

const Privacy = () => {
  return (
    <div className="gpt3__possibility section__margin" id="cookie-policy">
      <div className="gpt3__possibility-content">
        <h1>Privacy Statement</h1>
        
        <p>
          MechArtista Techno crafts Limited and its affiliates (hereafter referred to as ‘MechArtista Techno crafts’) value our relationships with business partners, clients, and any parties interested in MechArtista Techno crafts’s business services and solutions. We are committed to protecting your information by handling it responsibly and safeguarding it using appropriate technical, administrative, and physical security measures. This Statement outlines the types of personal information collected on our Website, how this data is used and safeguarded, as well as how users may exercise their rights regarding personal information.
        </p>

        <h2>Residency</h2>
        <p>If you reside in India, you are contracting with MechArtista Techno crafts Limited, 8, Balaji Estate, First Floor, Guru Ravi Das Marg, Kalkaji, New Delhi.</p>
        <p>If you reside outside of India, you are contracting with one of the MechArtista Techno crafts companies & subsidiaries.</p>

        <h2>Scope</h2>
        <p>This Privacy Statement applies to MechArtista Techno crafts.com, MechArtista Techno crafts-branded apps, MechArtista Techno crafts company pages, communications, and services (‘Services’), including off-site services such as our email services, customer care and support services, the ‘Contact Us,’ ‘Apply with MechArtista Techno crafts,’ and ‘Share on’ plugins on our digital properties.</p>

        <h2>How do we collect personal data?</h2>
        <h3>Directly:</h3>
        <p>
          We obtain personal data directly from individuals in a variety of ways, including obtaining personal data from individuals who provide us their business card, complete our online forms, subscribe to our newsletters, register for webinars, attend meetings or events we host, visit our offices, or apply for open roles.
        </p>
        <h3>Indirectly:</h3>
        <p>
          We obtain personal data indirectly about individuals from a variety of sources, including recruitment services and our clients. We may attach personal data to our customer relationship management records to better understand and serve our business clients, satisfy a legal obligation, or pursue our legitimate interests.
        </p>
        <h3>Sources:</h3>
        <ul>
          <li>Public sources, such as Companies House, news articles, sanctions lists, and Internet searches.</li>
          <li>Social media, if you register or login using services like LinkedIn, Google, or Twitter.</li>
          <li>Business clients who may engage us to perform professional services that involve sharing personal data.</li>
          <li>Recruitment services that may provide us with personal data about candidates.</li>
        </ul>

        <h2>What Personal Data will MechArtista Techno crafts collect?</h2>
        <ul>
          <li>Name, gender, age, and date of birth.</li>
          <li>Contact information such as address, email, and mobile phone number.</li>
          <li>Country of residence.</li>
          <li>Lifestyle and social circumstances (e.g., hobbies).</li>
          <li>Family circumstances (e.g., marital status and dependents).</li>
          <li>Employment and education details.</li>
          <li>Financial and tax-related information.</li>
          <li>CCTV footage and other information collected when accessing our premises.</li>
          <li>Dietary requirements and health information.</li>
        </ul>
        <h3>Special Categories:</h3>
        <p>We typically seek separate permission from you in writing to process any special categories of personal data.</p>

        <h2>What lawful reasons do we have for processing personal data?</h2>
        <ul>
          <li>Contract – To perform our contractual obligations.</li>
          <li>Consent – Based on your freely given consent.</li>
          <li>Legitimate interests – To deliver services to our clients and provide direct marketing.</li>
        </ul>

        <h2>What will MechArtista Techno crafts do with your personal data?</h2>
        <ul>
          <li>To provide services to our clients.</li>
          <li>To meet legal or regulatory requirements.</li>
          <li>To conduct due diligence checks relating to the services.</li>
          <li>To promote our professional services to existing and prospective business clients.</li>
        </ul>

        <h2>Whom do we share your personal data with?</h2>
        <ul>
          <li>With other members of the MechArtista Techno crafts group companies or third-party service providers.</li>
          <li>With competent authorities including courts and regulatory bodies.</li>
          <li>With credit reference agencies or organizations that help in making credit decisions.</li>
        </ul>
        <p>Any personal data contributed to our Social Media Applications can be read, collected, and used by other users.</p>

        <h2>Where do we transfer your personal data?</h2>
        <p>Information we hold about you may be transferred to countries where we do business.</p>
        <ul>
          <li>You have consented to the transfer.</li>
          <li>Necessary for the performance of a contract with you.</li>
          <li>Necessary for the establishment, exercise, or defense of legal claims.</li>
        </ul>
        <p>We will impose contractual obligations on the recipients of that data to protect your personal data to the standard required in applicable data protection laws.</p>

        <h2>What are your data protection rights?</h2>
        <ul>
          <li>Right to be informed about how your data is collected and used.</li>
          <li>Right of access to verify whether we are processing your personal data.</li>
          <li>Right to rectification or correction of your data.</li>
          <li>Right to erasure of your personal data.</li>
          <li>Right to restrict processing of your personal data.</li>
          <li>Right to data portability.</li>
          <li>Right to object to direct marketing.</li>
        </ul>

        <h2>Cookies</h2>
        <p>Our websites may use cookies. Where cookies are used, a statement will be sent to your browser explaining their use.</p>

        <h2>How long will we keep your personal data?</h2>
        <p>We seek to ensure that we only keep your personal data for the longest of the period necessary for the relevant activity or services, any retention period required by law, or the period in which litigation or investigations might arise.</p>

        <h2>Links to other sites</h2>
        <p>Our websites may contain links to other sites not governed by this Privacy Statement. Please review the destination websites’ privacy policies before submitting personal data on those sites.</p>

        <h2>Changes to this Privacy Statement</h2>
        <p>We may update this statement periodically. When we do, we will publish the changes on this Website.</p>

        <h2>Contact Us</h2>
        <p>For questions or to access your personal data, contact us.</p>
      </div>
    </div>
  );
};

export default Privacy;
